module.exports = __webpack_public_path__ + "img/icon_unselected_baihu.830d322e.png";